<template>
  <a-card :bordered="false">

    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :md="6" :sm="12">
            <a-form-item :label="$t('账号')">
              <j-input :placeholder="$t('输入账号模糊查询')" v-model="queryParam.userName"></j-input>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{ $t('查询') }}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('重置') }}</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <!-- 操作按钮区域 -->
    <!-- <div class="table-operator" style="border-top: 5px"> -->
      <!-- <a-button @click="handleAdd" type="primary" icon="plus">添加用户</a-button> -->
      <!-- <a-button type="primary" icon="download" @click="handleExportXls('用户信息')">导出</a-button> -->
      <!--
      <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel">
        <a-button type="primary" icon="import">导入</a-button>
      </a-upload>
      -->
      <!-- <a-button type="primary" icon="hdd" @click="recycleBinVisible=true">回收站</a-button> -->
    <!-- </div> -->

    <!-- table区域-begin -->
    <div>
      <!-- <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;" v-if="selectedRowKeys.length > 0">
        <i class="anticon anticon-info-circle ant-alert-icon"></i>已选择&nbsp;<a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项&nbsp;&nbsp;
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div> -->

      <a-table
        ref="table"
        bordered
        size="middle"
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        @change="handleTableChange">

        <template slot="avatarslot" slot-scope="text, record, index">
          <div class="anty-img-wrap">
            <a-avatar shape="square" :src="getAvatarView(record.avatar)" icon="user"/>
          </div>
        </template>

        <span slot="action" slot-scope="text, record">
          <!-- <a @click="handleDetail(record)">详情</a> -->
          <a @click="handleRead(record)" v-if="record.readState != 1">{{ $t('已读') }}</a>
        </span>
      </a-table>
    </div>
    <!-- table区域-end -->

    <AccountExceptionListModal ref="AccountExceptionListRef" @ok="modalFormOk" />

  </a-card>
</template>

<script>
  import {putAction,getFileAccessHttpUrl,postAction} from '@/api/manage';
  import {frozenBatch} from '@/api/api'
  import {JeecgListMixin} from '@/mixins/JeecgListMixin'
  import JInput from '@/components/jeecg/JInput'
  import AccountExceptionListModal from './modules/AccountExceptionListModal'
import { json } from 'mathjs';

  export default {
    name: "AccountExceptionList",
    mixins: [JeecgListMixin],
    components: {
      JInput,
      AccountExceptionListModal
    },
    data() {
      return {
        description: this.$t('这是账号解绑及冻结记录页面'),
        queryParam: {},
        recycleBinVisible: false,
        url: {
          list: "/sys/userBanRecord/list",
          queryById: "/sys/userExpectionRecord/edit",
        },
      }
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
      columns() {
        return [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender: (t, r, index) => {
              return parseInt(index)+1;
            }
          },
          {
            title: this.$t('用户账号'),
            align: "center",
            dataIndex: 'userName',
            width: 120,
            sorter: true
          },
          {
            title: this.$t('用户真实姓名'),
            align: "center",
            width: 100,
            dataIndex: 'userRealName',
          },
          {
            title: this.$t('操作类型'),
            align: "center",
            width: 100,
            dataIndex: 'operateType',
            customRender: (t) => {
              if(t == 0){
                return this.$t('冻结')
              }else if(t == 1){
                return this.$t('解冻')
              }
            }
          },
          {
            title: this.$t('操作时间'),
            align: "center",
            width: 100,
            dataIndex: 'operateTime'
          },
          {
            title: this.$t('操作员账号'),
            align: "center",
            width: 100,
            dataIndex: 'operateName'
          },
          {
            title: this.$t('操作员真实姓名'),
            align: "center",
            width: 100,
            dataIndex: 'operateRealName'
          },
          {
            title: this.$t('操作描述'),
            align: "center",
            width: 200,
            dataIndex: 'operateDescription'
          },
          {
            title: this.$t('创建时间'),
            align: "center",
            width: 150,
            dataIndex: 'createTime'
          },
        ]
      }
    },
    methods: {
      handleDetail(row){
        this.$refs.AccountExceptionListRef.init(row);
      },
      handleRead(row){
        let params = JSON.parse(JSON.stringify(row));
        params.readState = 1;
        postAction(this.url.queryById,params).then(res => {
          if(res.success){
            this.$message.success(res.message);
            this.loadData();
          }
        });
      }
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less'
</style>